import { getAuthToken } from './auth';

/**
 * `fetch` that attaches the current user's bearer token (Cognito ID token, or the SSO
 * session token) when one exists. Use it for every call to Core's /api so the
 * stack-wide auth gate (CORE_REQUIRE_AUTH) can be enforced without breaking the UI.
 * An explicit Authorization header passed by the caller is kept.
 */
export async function authFetch(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers || undefined);
  if (!headers.has('Authorization')) {
    const token = await getAuthToken();
    if (token) headers.set('Authorization', `Bearer ${token}`);
  }
  return fetch(input, { ...init, headers });
}
